var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 123,
    viewBox: "0 0 131 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.895 69.5731L0 31.1791L14.4746 18.1463L57.5453 55.1313L86.4944 3L121.445 7.22687L74.1381 55.1313L121.445 94.9343L101.675 107.967L64.6061 69.5731L41.3055 121H0L45.895 69.5731Z",
    fill: "#3C73FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.063 69.5731L5.16797 31.1791L19.6425 18.1463L62.7133 55.1313L91.6624 3L126.613 7.22687L79.3061 55.1313L126.613 94.9343L106.843 107.967L69.774 69.5731L46.4735 121H5.16797L51.063 69.5731Z",
    stroke: "#222222",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXImage);
export default __webpack_public_path__ + "static/media/XImage.06bc4dc60efb1703d20361699897acfd.svg";
export { ForwardRef as ReactComponent };